/**
 * Created by wangkai on 2020/12/16.
 */

const account_list_tab_data = [{
    "menu_to": "/accountList",
    "menu_name": "账户列表"
  },
  {
    "menu_to": "/accountDoApplyList",
    "menu_name": "FB账户操作申请记录"
  },
  {
    "menu_to": "/batchDo",
    "menu_name": "FB账户批量操作申请记录"
  },
  {
    "menu_to": "/grandsList",
    "menu_name": "FB账户拨款申请记录"
  },
];

const operateTypeArrs = {
  1: "绑定BM",
  2: "解绑BM",
  3: "绑定Pixel",
  4: "解绑Pixel",
  5: "账户清零",
  6: "拨款",
  7: "减款",
  10: "修改账户名称",
}

// const operateTypeArrs = [{
//     label: "绑定BM",
//     value: 1,
//   },
//   {
//     label: "解绑BM",
//     value: 2,
//   },
//   {
//     label: "绑定Pixel",
//     value: 3,
//   },
//   {
//     label: "解绑Pixel",
//     value: 4,
//   },
//   {
//     label: "账户清零",
//     value: 5,
//   },
//   {
//     label: "拨款",
//     value: 6,
//   },
//   {
//     label: "减款",
//     value: 7,
//   },
//   {
//     label: "修改账户名称",
//     value: 10,
//   },
// ]

const policy_score_class_name = {
  1: "danger",
  2: "warning",
  3: "success",
  4: "default"
};

export default {
  account_list_tab_data,
  operateTypeArrs,
  policy_score_class_name
}